<template>
    <div>
        <!-- <div v-if="agentDetail.agent">
          <pre class="language-json"><code>{{ agentDetail }}</code></pre>
          <br />
          <br />
          <pre class="language-json"><code>{{ currencyList }}</code></pre>
        </div>-->
         <ValidationObserver v-slot="{ handleSubmit }">
                            <CForm @submit.prevent="agentDetail.agent.paymentsettings?(agentDetail.agent.paymentsettings.length?handleSubmit(validateManage):invalidText=true):handleSubmit(validateManage)">
        <CCard>
            <CCardHeader class="grey-header">
                <CRow class="flex-flow-column">
                    <CCol>
                        <strong>{{ $t("manage.title") }}</strong>
                    </CCol>
                    <p class="desc">{{ $t("manage.desc") }}</p>
                </CRow>
            </CCardHeader>

            <!--            <CCardBody v-if="agentDetail.agent">-->
            <!--                <CRow>-->
            <!--                    <CCol>-->
            <!--                        <strong>{{ $t("manage.status") }}</strong>-->
            <!--                    </CCol>-->
            <!--                    <CCol>-->
            <!--                        <cDropDown-->
            <!--                                v-model="agentDetail.status"-->
            <!--                                :isAllowEmpty="false"-->
            <!--                                :ctrlCode="'value'"-->
            <!--                                :ctrlName="'name'"-->
            <!--                                :isShowCode="false"-->
            <!--                                :isMultiple="false"-->
            <!--                                :isSearchable="true"-->
            <!--                                :url="getStausURL()"-->
            <!--                                @input="onStatusChange"-->
            <!--                        ></cDropDown>-->
            <!--                    </CCol>-->
            <!--                </CRow>-->
            <!--            </CCardBody>-->


            <CCardBody class="max-w-1100 m-auto" v-if="agentDetail.agent">
                <div class="row ai-center" v-if="agentDetail.agent">
                    <div class="col-form-label col-xs-12 col-sm-12 col-md-12 label-none bs-input col">
                        <div class="title-m-agent text-center">

                            <div class="name" v-if="agentDetail.agent">{{agentDetail.agent.agencyname}}</div>
                        </div>
                    </div>
                </div>
                <CRow>
                    <CCol md="6" v-if="agentDetail.agent">
                        <cAgentDetails :agencyDet="agentDetail.agent" :isNeedAssTier="true"/>
                    </CCol>
                    <CCol md="6" class="mob-mt-50px right-m-agent">

                        <CRow v-if="agentDetail.agent">
                            <CCol>
                                <CRow>
                                    <CCol>
                                        <label>
                                            <strong class="c-gray">{{ $t('manage.status') }}</strong>
                                        </label>
                                    </CCol>
                                    <CCol>


                                        <cStatusButton  :isConfirm='false' :defaultStatus='agentDetail.status.value' @change='onStatusChange' :buttonDesc="$t('manage.btnDesc')" :label="{checked: $t('manage.activate'), unchecked: $t('manage.deactivate')}">


                                        </cStatusButton>
                                        <!-- <cDropDown
                                                v-model="agentDetail.status"
                                                :isAllowEmpty="false"
                                                :ctrlCode="'value'"
                                                :ctrlName="'name'"
                                                :isShowCode="false"
                                                :isMultiple="false"
                                                :isSearchable="true"
                                                :url="getStausURL()"
                                                @input="onStatusChange"

                                        ></cDropDown> -->
                                    </CCol>
                                </CRow>
                                <br>
                                <CRow v-if="selectedCurrencyList">
                                    <CCol>
                                        <label>
                                            <strong class="c-gray">{{ $t("manage.currency") }}</strong>
                                        </label>
                                    </CCol>
                                    <CCol>
                                        <CRow>
                                            <div v-for="(curr,index) in selectedCurrencyList" :key="'cl'+index">
                                                <CCol>
                                                    <strong>{{ curr.code }}</strong>
                                                </CCol>
                                            </div>
                                        </CRow>
                                    </CCol>
                                </CRow>
                                <br/>
                                <CRow>
                                    <CCol>
                                        <label>
                                            <strong class="c-gray">{{ $t("manage.addCurrency") }}</strong>
                                        </label>
                                    </CCol>
                                    <CCol class="inner-label-none">
                                        <cOrgCurrencyDp
                                                v-on:input="onCurrencyChange"
                                                :selValue="currency"
                                                :isAllowEmpty="true"
                                                :ctrlCode="'id'"
                                                :isShowCode="true"
                                                :isMultiple="true"
                                                :isSearchable="true"
                                                :isTaggable="false"
                                                :url="getOrgCurrencyServiceURL()"
                                                :assignedCurrency="selectedCurrencyList"
                                                :isShowDefaultCurrency="false"
                                                :isShowLoading="false"
                                        />
                                    </CCol>
                                </CRow>

                                <br/>

                                <CRow v-if="paymentListGroup">
                                    <CCol>

                                        <label>
                                            <strong class="c-gray">{{ $t("manage.payMethod") }}</strong>
                                        </label>
                                    </CCol>

                                    <CCol class="mob-pd-0px pr-0px">
                                        <div class="cus-checkbox">
                                            <div class="wrapper">
                                                <div class="card-wrap" v-if="paymentListGroup">
                                                    <div class="wrap" v-for="(payList, index) in paymentListGroup" :key="'p'+index">
                                                        <div class="title">
                                                            <strong>{{payList.groupName}}</strong>
                                                        </div>
                                                        <label v-for="(payment, index) in payList.payment" :key="payList.groupName+index"
                                                               class="card-c" :for="payList.groupName+index"
                                                               v-bind:class="{active: agentDetail.agent.paymentsettings.includes(payment.paymentSettingsId)}">


                                                            <input class="d-none"
                                                                   type="checkbox"
                                                                   :id="payList.groupName+index"
                                                                   :checked="agentDetail.agent.paymentsettings.includes(payment.paymentSettingsId)"
                                                                   @input="onPaymentTypeChange(payment.paymentSettingsId)"
                                                            />
                                                            <div>{{ payment.providerName }}</div>
                                                        </label>
                                                    </div>

                                                </div>
<!-- 
                                                <div class="card-wrap">
                                                    <div class="wrap">
                                                        <div class="title">
                                                            <strong>System Payment</strong>
                                                        </div>

                                                        <label class="card-c active" for="1234">
                                                            <input type="checkbox" class="d-none" id="1234">
                                                            <div> Ticket Now</div>
                                                        </label>
                                                        <div class="card-c active">

                                                            <div>Book Now & Ticket Later</div>
                                                        </div>


                                                    </div>
                                                    <div class="wrap">
                                                        <div class="title">
                                                            <strong>Bank Transfer</strong>
                                                        </div>
                                                        <div class="card-c active">
                                                            <div>SBI</div>
                                                        </div>
                                                        <div class="card-c">
                                                            <div>Indian Bank</div>
                                                        </div>

                                                        <div class="card-c">
                                                            <div>KVB</div>
                                                        </div>
                                                        <div class="card-c">
                                                            <div> AXIS</div>
                                                        </div>
                                                    </div>
                                                    <div class="wrap">
                                                        <div class="title">
                                                            <strong>E-Wallet</strong>
                                                        </div>
                                                        <div class="card-c active">
                                                            <div>PAYTM</div>
                                                        </div>
                                                        <div class="card-c">
                                                            <div>KBZ</div>
                                                        </div>


                                                    </div>
                                                    <div class="wrap">
                                                        <div class="title">
                                                            <strong>Debit / Credit Card</strong>
                                                        </div>
                                                        <div class="card-c active">
                                                            <div><img data-v-4078d25a=""
                                                                      src="https://cdn.iconscout.com/icon/free/png-256/visa-3-226460.png"
                                                                      alt="" style="
    width: 51px;
"></div>
                                                        </div>
                                                        <div class="card-c">
                                                            <div><img src="http://getdrawings.com/free-icon/visa-mastercard-icon-75.png
    " style="
    width: 44px;
"></div>
                                                        </div>


                                                    </div>


                                                </div> -->
                                            </div>

                                        </div>
                                    </CCol>
                                     <div v-if="(invalidText)">
                                                <label class='invalid-feedback'>
                                                    {{$t('approveAgt.invalidPaymentType')}} 
                                                </label>

                                            </div>
                                </CRow>
                            </CCol>
                        </CRow>


                        <!-- <CRow v-if="agentDetail.agent.agenttype">
                            <CCol>
                                <strong class="c-gray">{{ $t("manage.agtType") }}</strong>
                            </CCol>
                            <CCol>
                                <div v-if="agentDetail.agent.agenttype==prepaid">{{ $t("manage.prepaid") }}</div>
                                <div v-else-if="agentDetail.agent.agenttype==postpaid">{{ $t("manage.postpaid") }}</div>
                            </CCol>
                        </CRow>

                        <br/>
                        <CRow v-if="agentDetail.agent.postpaidtype">
                            <CCol>
                                <strong class="c-gray">{{ $t("manage.postpaidType") }}</strong>
                            </CCol>
                            <CCol>
                                <div v-if="agentDetail.agent.postpaidtype==postpaidType.weekly">{{ $t("manage.weekly")
                                    }}
                                </div>
                                <div v-else-if="agentDetail.agent.postpaidtype==postpaidType.onceAWeek">{{
                                    $t("manage.onceAWeek") }}
                                </div>
                                <div v-else-if="agentDetail.agent.postpaidtype==postpaidType.monthly">{{
                                    $t("manage.monthly") }}
                                </div>
                            </CCol>
                        </CRow>
                        <br/>

                        <CRow v-if="agentDetail.agent.schedule">
                            <CCol>
                                <strong class="c-gray">{{ $t("manage.payScheduleType") }}</strong>
                            </CCol>
                            <CCol>
                                {{ $t("manage.schedule") + ' ' + agentDetail.agent.schedule.scheduleid}}
                            </CCol>
                        </CRow>
                        <br/>
                        <CRow v-if="agentDetail.agent.creditlimit_type" class="c-limit">
                            <CCol md="6" sm="12" xs="12" class="cl-label">
                                <strong class="c-gray">{{ $t("manage.creditLimit") }}</strong>
                            </CCol>

                            <CCol md="6" sm="12" xs="12">
                                <div v-if="agentDetail.agent.creditlimit_type==1">{{ $t("manage.fixed")
                                    }}
                                </div>
                                <div v-else-if="agentDetail.agent.creditlimit_type==2">{{
                                    agentDetail.agent.postpaidtype==postpaidType.weekly ?
                                    $t("manage.repWeekly") : agentDetail.agent.postpaidtype==postpaidType.onceAWeek ?
                                    $t("manage.repTwice"): $t("manage.repMonthly")}}
                                </div>
                            </CCol>
                        </CRow> -->
                        <br />
                        
                        <CRow v-if="agentDetail.agent.postpaidtype" class="c-limit">
                            <CCol md="6" sm="12" xs="12" class="cl-label">
                                <strong class="c-gray">{{ $t("manage.crdtLimit") }}</strong>
                                <span >

                        </span>
                            </CCol>
                            <CCol md="6" sm="12" xs="12">
                                <div class="d-flex">
                                    <div>
                                        <!-- <div v-for="(curr,index) in agentDetail.agent.b2bCompanyFinancess" :key="'c'+index"> -->
                                        <cCurrencyBoxes @onInput="onEdit" :currItems="agentDetail.currency" rules="required|onlynumber" />
                                        <!-- </div> -->
                                        <div v-if="currencyList">
                                            <cCurrencyBoxes @onInput="onEdit" :currItems="currencyList" rules="required|onlynumber" />
                                        </div>
                                    </div>

                                    <cHelpTip :content="$t('helpTip.manageCrdtLmt')" class="align-items-baseline pt-6px"></cHelpTip>
                                </div>

                            </CCol>
                        </CRow>
                        <br />
                        <div :class={rotate:isAdvanceSettings} v-if="agentDetail.agent.agenttype==postpaid" @click="isAdvanceSettings=!isAdvanceSettings" class="link-drop-btn">
                                                <span>{{ $t("manage.advSettings") }}</span>
                            </div>
                        <CRow  v-if="isAdvanceSettings" class="c-limit">
                            <CCol md="6" sm="12" xs="12" class="cl-label">
<!--                                <strong class="c-gray">{{ $t("manage.extensnTime") + ' ('+ $t("manage.perSch")+ ')'}}</strong>-->
                            </CCol>
                            <CCol md="6" sm="12" xs="12">
                                <label class="d-flex"><span>
                                    {{ $t("manage.extensnTime") + ' ('+ $t("manage.perSch")+ ')'}}
                                </span>
                                    <cHelpTip :content="$t('helpTip.manageExTime')"></cHelpTip></label>

                                <cTextInputComponent v-on:input="onEdit"
          v-model="agentDetail.extensionTimes"
          :name="$t('manage.extensnTime')"
          rules="onlyNumber|min_val:0"
          class="inner-label-none"
          :maxLength="3"
        />
        <!-- |max_value:2147483647 -->
                            </CCol>
                            
                        </CRow>
                        <CRow v-if="isAdvanceSettings" class="c-limit">
                            <CCol md="6" sm="12" xs="12"></CCol>
                            <CCol md="6" sm="12" xs="12">
                                <div class="checkbox-all d-flex mb-15px mt-10px">
                <div  class="checkbox d-flex">
                    <input id="crs" type="checkbox" class="mt-5px" :checked="agentDetail.isBlockTicket" v-on:input="onToggleBlockTicket()" />
                    <label for="crs" class="ml-10px c-pointer mb-0" @click="onToggleBlockTicket()">{{' '+ $t('approveAgt.blkTckt') }}</label>
                </div>
            </div>
                            </CCol>
                        </CRow>
                        <br />

                    </CCol>
                </CRow>
            </CCardBody>

            <!--            <CCardBody v-if="agentDetail.agent">-->
            <!--                <div class="row flex-flow-column ai-center">-->
            <!--                    <div class="col-md-6 col-sm-12">-->
            <!--                        <CRow>-->
            <!--                            <CCol>-->
            <!--                                <strong>{{ $t("manage.agtType") }}</strong>-->
            <!--                            </CCol>-->
            <!--                            <CCol>-->
            <!--                                <div v-if="agentDetail.agent.agenttype==prepaid">{{ $t("manage.prepaid") }}</div>-->
            <!--                                <div v-else-if="agentDetail.agent.agenttype==postpaid">{{ $t("manage.postpaid") }}</div>-->
            <!--                            </CCol>-->
            <!--                        </CRow>-->
            <!--                        <br/>-->
            <!--                        <CRow v-if="agentDetail.agent.postpaidtype">-->
            <!--                            <CCol>-->
            <!--                                <strong>{{ $t("manage.postpaidType") }}</strong>-->
            <!--                            </CCol>-->
            <!--                            <CCol>-->
            <!--                                <div v-if="agentDetail.agent.postpaidtype==postpaidType.weekly">{{ $t("manage.weekly")-->
            <!--                                    }}-->
            <!--                                </div>-->
            <!--                                <div v-else-if="agentDetail.agent.postpaidtype==postpaidType.onceAWeek">{{-->
            <!--                                    $t("manage.onceAWeek") }}-->
            <!--                                </div>-->
            <!--                                <div v-else-if="agentDetail.agent.postpaidtype==postpaidType.monthly">{{-->
            <!--                                    $t("manage.monthly") }}-->
            <!--                                </div>-->
            <!--                            </CCol>-->
            <!--                        </CRow>-->
            <!--                        <br/>-->
            <!--                        <CRow v-if="agentDetail.agent.schedule">-->
            <!--                            <CCol>-->
            <!--                                <strong>{{ $t("manage.payScheduleType") }}</strong>-->
            <!--                            </CCol>-->
            <!--                            <CCol>-->
            <!--                                {{ $t("manage.schedule") + ' ' + agentDetail.agent.schedule.scheduleid}}-->
            <!--                            </CCol>-->
            <!--                        </CRow>-->
            <!--                        <br/>-->
            <!--                        <CRow v-if="agentDetail.agent.postpaidtype">-->
            <!--                            <CCol>-->
            <!--                                <strong>{{ $t("manage.crdtLimit") }}</strong>-->
            <!--                            </CCol>-->
            <!--                            <CCol>-->
            <!--                                &lt;!&ndash; <div v-for="(curr,index) in agentDetail.agent.b2bCompanyFinancess" :key="'c'+index"> &ndash;&gt;-->
            <!--                                <cCurrencyBoxes :currItems="agentDetail.currency" rules="required|onlynumber"/>-->
            <!--                                &lt;!&ndash; </div> &ndash;&gt;-->
            <!--                                <div v-if="currencyList">-->
            <!--                                    <cCurrencyBoxes :currItems="currencyList" rules="required|onlynumber"/>-->
            <!--                                </div>-->
            <!--                            </CCol>-->
            <!--                        </CRow>-->
            <!--                    </div>-->
            <!--                </div>-->
            <!--            </CCardBody>-->
            <!--            <hr/>-->

            <CCardFooter v-if="!isLoading">
                <CCol class="text-right mob-btn-center">
                    <CRow class="d-flex justify-content-end ">
                        <CButton color="danger" @click="navigateToManageAgents()" class="action-c-btn">

                            <img src="@imgPath/img/svg/icons/close.svg">

                            {{$t('manage.cancel')}}
                        </CButton>

                        <CButton class="buttonspace action-c-btn btn-success removewrap" type="submit" 
                                 color="success removewrap">
                            <img src="@imgPath/img/svg/icons/correct.svg">

                            {{$t('manage.save')}}
                        </CButton>

                    </CRow>
                </CCol>


            </CCardFooter>
        </CCard>
                            </CForm>
         </ValidationObserver>
        <CAlert v-if="alertValue" show color="danger">
                      <div  v-if="alertValue&&alertValue.hasOwnProperty('valueList')">
                <p  v-for="(value,index) in alertValue.valueList" :key="index">
                        {{value}}
                      </p>
                      </div>
                      <div v-if="alertValue&&alertValue.hasOwnProperty('codeList')">
                      <span>{{$t("cAlert.errorCode")+' : '}}</span><span  v-for="(code,index) in alertValue.codeList" :key="index">
                        {{code +' '}}
                      </span>
                      </div>
                            <div  v-if="alertValue&&alertValue.constructor==String">
                <p  >
                        {{alertValue}}
                      </p>
                      </div>
                      </CAlert>
        <cAlertModal v-if="isShowAlertModal"
                :buttonList="modalButton"
                :status="modalStatus"
                :isShowIcon="true"
                :show="isShowAlertModal"
                :desc="confirmTxt"
        ></cAlertModal>
    </div>
</template>

<script>
    import {
        COMPONENT_NAME,
        PATHNAME,
        APPROVEAGENT,
        DEFAULT_DROPDOWN_STATUS,
        ALERT_MODAL_STATUS,
        POSTPAID_TYPE
    } from "../../util/constants";
    import {mapGetters, mapActions} from "vuex";
    import apiGetAgentDetails from "../../services/apiGetAgentDetails";
    import BaseConfiguration from "../../config/base";
    import {
        LOG_TYPE,
        FILE_NAME,
        HTTP_CODES,
        API_VALUES
    } from "../../config/API_DATA";
    import {VALIDATE_SUCCESS_RES, getErrorMessage} from "../../util/apiValidate";
    import {
        handleJWT,
        getErrorAlertValue,
        cloneData,
        removeDuplicates,
        differenceBy,
        addClassToBody, removeClassBody,
        GroupByList
    } from "../../util/util";
    import Logger from "../../services/logger";
    import SERVICE_URL from "../../config/API_DATA";
    import cAgentDetails from "../../components/agentDetail/cAgentDetails";
    import apiGetPaymentListAgtManage from "../../services/apiGetPaymentListAgtManage";
    import cOrgCurrencyDp from "../../components/currency/cOrgCurrencyDp";
    import cCurrencyBoxes from "../../components/currency/cCurrencyBoxes";
    import cDropDown from "../../components/form/cDropDown";
    import apiActivateAgent from "../../services/apiActivateAgent";
    import apiGetMenuCount from "../../services/apiGetMenuCount.js";
    import apiEditAgent from "../../services/apiEditAgent";
    import cAlertModal from "../../components/form/cAlertModal";
    import router, {navigate, goBack, reloadCurrentPage,updateDataEdited} from "../../router/index";
    import {ValidationObserver} from "vee-validate";
    import cTextInputComponent from "../../components/form/cTextInputComponent";
    import  cStatusButton  from './../../components/form/cStatusButton'
    import cHelpTip from './../../components/cHelpTip'
    export default {
        name: COMPONENT_NAME.MANAGE,

        components: {
            cAgentDetails,
            cOrgCurrencyDp,
            cCurrencyBoxes,
            cDropDown,
            cAlertModal,
            ValidationObserver,
            cStatusButton,
            cTextInputComponent,
            cHelpTip
        },

        data() {
            return {
                agentDetail: {
                    agent: null,
                    currency: [],
                    status: {
                        name: null,
                        value: null
                    },
                    extensionTimes:null
                },
                isAdvanceSettings:false,
                invalidText: null,
                currencyList: null,
                currency: null,
                selectedCurrencyList: [],
                paymentList: [],
                paymentListGroup: null,
                prepaid: APPROVEAGENT.PREPAID,
                postpaid: APPROVEAGENT.POSTPAID,
                alertValue: null,
                confirmTxt: null,
                modalButton: null,
                modalStatus: ALERT_MODAL_STATUS.INFO,
                isShowAlertModal: false,
                postpaidType: {
                    weekly: POSTPAID_TYPE.WEEKLY,
                    onceAWeek: POSTPAID_TYPE.ONCE_A_WEEK,
                    monthly: POSTPAID_TYPE.MONTHLY
                },
                isSelCurrency:false,
                isLoading:true
            };
        },

        computed: {
            ...mapGetters("sManageAgent", {
                selectedB2bId: "GET_SELECTED_B2BID"
            }),
            
        },

        methods: {
            ...mapActions("sMenus", ["SET_MENU_COUNT_RES"]),


            onEdit() {
                try {
                  if(BaseConfiguration.isDebug) console.log("onEdit");
                updateDataEdited(true);
            
                } catch (err) {
                        let body = Logger.buildRequest(
                          FILE_NAME.MANAGE,
                          "error in onEdit",
                          err.toString(),
                          "onEdit",
                          LOG_TYPE.ERROR
                        );
                        Logger.getResponse(body);
                      }
                 
                }, 
            getOrgCurrencyServiceURL() {
                if (BaseConfiguration.isDebug) console.log("getCurrencyServiceURL");
                return SERVICE_URL.GET_ORG_CURRENCY;
            },

            getStausURL() {
                if (BaseConfiguration.isDebug) console.log("getStausURL");
                return SERVICE_URL.STATUS;
            },

            showAlert(val) {
                this.alertValue = val;
            },

 async getMenuCount() {
      let returnValue;
      try {
        let menuCountReq = apiGetMenuCount.buildRequest();

        if (menuCountReq != null) {
          

          let menuCountRes = await apiGetMenuCount.getResponse(menuCountReq);
          if (VALIDATE_SUCCESS_RES(menuCountRes)) {
            returnValue = menuCountRes.data.data;
           
            
          } else {
            let error = getErrorMessage(menuCountRes);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error);
            } else {
              returnValue = [];
            }
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.MANAGE,
          "error in getting getMenuCount",
          err.toString(),
          "getMenuCount",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return returnValue;
    },

            validateManage() {
                try {
                  if(BaseConfiguration.isDebug) console.log("validateManage");
                  //let retValue;
                  this.showAlertModal(this.modalStatus,this.$t('manage.confirm',{agent:this.agentDetail.agent.agencyname,
                  code:this.agentDetail.agent.b2bcode}));
          
                } catch (err) {
                        let body = Logger.buildRequest(
                          FILE_NAME.MANAGE,
                          "error in validateManage",
                          err.toString(),
                          "validateManage",
                          LOG_TYPE.ERROR
                        );
                        Logger.getResponse(body);
                      }
                //  return retValue;
                }, 

            showAlertModal(status, val) {
                // this.toggleShowAlertModal();
                this.isShowAlertModal = true;
                this.modalStatus = status;
                if (status == ALERT_MODAL_STATUS.INFO) {
                    this.modalButton = [
                        {
                            name: this.$t("manage.cancel"),
                            func: this.toggleShowAlertModal,
                            color: "danger"
                        },
                        {
                            name: this.$t("manage.yes"),
                            func: this.saveAgent,
                            color: "success"
                        }
                    ];
                } else if (status == ALERT_MODAL_STATUS.SUCCESS) {
                    this.modalButton = [
                        {
                            name: this.$t("manage.ok"),
                            func: this.navigateToManageAgents,
                            color: "success"
                        }
                    ];
                }
                this.confirmTxt = val;
            },

            // showConfirmAlertModal(status, val) {
            //   this.isShowAlertModal = true;
            //   this.modalStatus = status;
            //   this.modalButton = [
            //     {
            //       name: this.$t("manage.cancel"),
            //       func: this.toggleShowAlertModal,
            //       color: "danger"
            //     },
            //     {
            //       name: this.$t("manage.ok"),
            //       func: this.saveAgent,
            //       color: "success"
            //     }
            //   ];
            //   this.confirmTxt = val;
            // },

            toggleShowAlertModal() {
                this.isShowAlertModal = !this.isShowAlertModal;
            },

           async navigateToManageAgents() {
               let menuCount = await this.getMenuCount();
                 this.SET_MENU_COUNT_RES(menuCount);
                navigate(PATHNAME.MANAGE_AGENT);
                // reloadCurrentPage();
            },

            getCurrencyList(pAgent) {
                try {
                    if (BaseConfiguration.isDebug) console.log("getCurrencyList");
                    //let retValue;
                    let currList = [];
                    if (pAgent && pAgent.b2bCompanyFinancess) {
                        for (
                            let index = 0;
                            index < pAgent.b2bCompanyFinancess.length;
                            index++
                        ) {
                            const curr = pAgent.b2bCompanyFinancess[index];
                            if (curr.currencycode) {
                                let currObj = {
                                    code: curr.currencycode.code
                                };
                                currList.push(currObj);
                            }


                            // let currObj = {

                            // }
                        }
                    }
                    if (currList.length > 0) return currList;
                    else return null;
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.MANAGE,
                        "error in getCurrencyList",
                        err.toString(),
                        "getCurrencyList",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                //  return retValue;
            },

            async getAgentDetail(pB2bId) {
                try {
                    if (BaseConfiguration.isDebug) console.log("getAgentDetail");
                    let agtDetail = null;

                    let agentRequest = apiGetAgentDetails.buildRequest(pB2bId);

                    if (agentRequest) {
                        let agentResponse = await apiGetAgentDetails.getResponse(
                            agentRequest
                        );
                        if (VALIDATE_SUCCESS_RES(agentResponse)) {
                            agtDetail = agentResponse.data.data;
                            this.showAlert(null);
                            // this.showAcknowledgeAlert();
                        } else {
                            let error = getErrorMessage(agentResponse);
                            let isJwt = handleJWT(error);
                            if (!isJwt) {
                                this.showAlert(getErrorAlertValue(error));
                            }
                        }
                    } else {
                        throw "invalid request";
                    }

                    return agtDetail;
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.MANAGE,
                        "error in getAgentDetail",
                        err.toString(),
                        "getAgentDetail",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                //return retValue;
            },

            async saveAgent() {
                try {
                    if (BaseConfiguration.isDebug) console.log("saveAgent");
                    //  let retValue;
                    this.toggleShowAlertModal();

                    let agtDetail = null;
                    let currList = [];
                    if (this.agentDetail.currency && this.agentDetail.currency.length > 0) {
                        for (
                            let index = 0;
                            index < this.agentDetail.currency.length;
                            index++
                        ) {
                            const curr = this.agentDetail.currency[index];
                            curr.postpaidlimit = curr.postpaidlimit
                                .toString()
                                .split(",")
                                .join("");
                            let currObj = {
                                currencyCode: curr.code,
                                creditLimit: curr.postpaidlimit
                            };
                            currList.push(currObj);
                        }
                    }
                    if (this.currencyList && this.currencyList.length > 0) {
                        for (let index = 0; index < this.currencyList.length; index++) {
                            const curr = this.currencyList[index];
                            curr.postpaidlimit = curr.postpaidlimit
                                .toString()
                                .split(",")
                                .join("");
                            let currObj = {
                                currencyCode: curr.code,
                                creditLimit: curr.postpaidlimit
                            };
                            currList.push(currObj);
                        }
                    }



            
                    if (this.agentDetail.agent) {
                        agtDetail = {
                            b2bId: this.agentDetail.agent.b2bid
                                ? Number(this.agentDetail.agent.b2bid)
                                : null,
                            payments: this.agentDetail.agent.paymentsettings
                                ? this.agentDetail.agent.paymentsettings
                                : [],
                            currency: currList,
                            extensionTimes: Number(this.agentDetail.extensionTimes),
                            isBlockTicket: this.agentDetail.agent.agenttype==APPROVEAGENT.PREPAID?null: this.agentDetail.isBlockTicket

                        };
                    }
                    this.agentDetail.agent.isactive = await this.updateStatus(this.agentDetail.agent.isactive);
                    let saveAgentReq;
                    if (agtDetail && agtDetail.b2bId)
                        saveAgentReq = apiEditAgent.buildRequest(agtDetail);

                    if (saveAgentReq) {
                        let saveAgentRes = await apiEditAgent.getResponse(saveAgentReq);
                        if (VALIDATE_SUCCESS_RES(saveAgentRes)) {
                            this.showAlert(null);
                            this.showAlertModal(
                                ALERT_MODAL_STATUS.SUCCESS,
                                this.$t("manage.updtSuccess")
                            );
                        } else {
                            let error = getErrorMessage(saveAgentRes);
                            let isJwt = handleJWT(error);
                            if (!isJwt) {
                                this.showAlert(getErrorAlertValue(error));
                            }
                        }
                    } else {
                        throw "invalid request";
                    }
                      updateDataEdited(false);
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.MANAGE,
                        "error in saveAgent",
                        err.toString(),
                        "saveAgent",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                // return retValue;
            },

            getCurrency(agent) {
                try {
                    if (BaseConfiguration.isDebug) console.log("getCurrency");
                    //  let retValue;
                    if (agent && agent.b2bCompanyFinancess) {
                        let currList = [];
                        for (let index = 0; index < agent.b2bCompanyFinancess.length; index++) {
                            const curr = agent.b2bCompanyFinancess[index];
                            let currObj = {
                                postpaidlimit: curr.postpaidlimit,
                                code: curr.currencycode.code
                            };
                            currList.push(currObj);
                        }
                        return currList;
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.MANAGE,
                        "error in getCurrency",
                        err.toString(),
                        "getCurrency",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                //  return retValue;
            },

            async getPaymentList(agent) {
                let returnValue;
                try {
                    let b2bid;
                    if (agent && agent.b2bid)
                        b2bid = agent.b2bid
                    let paymentListReq = apiGetPaymentListAgtManage.buildRequest(b2bid);
                    if (paymentListReq) {
                        let paymentListRes = await apiGetPaymentListAgtManage.getResponse(
                            paymentListReq
                        );
                        if (
                            VALIDATE_SUCCESS_RES(paymentListRes) &&
                            paymentListRes.data.data.length > 0
                        ) {
                            //save res in store
                            returnValue = paymentListRes.data.data;
                            this.showAlert(null);
                        } else {
                            let error = getErrorMessage(paymentListRes);
                            let isJwt = handleJWT(error);
                            if (!isJwt) {
                                this.showAlert(getErrorAlertValue(error));
                            }
                            returnValue = [];
                        }
                    } else {
                        throw "invalid request"; //
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.MANAGE,
                        "error in  getPaymentList  ",
                        err.toString(),
                        "getPaymentList",
                        LOG_TYPE.ERROR
                    );
                }

                return returnValue;
            },

            onCurrencyChange(selCurrencyObj) {
                try {
                    if (BaseConfiguration.isDebug) console.log("onCurrencyChange");
                    if (selCurrencyObj) {
                        this.currency = selCurrencyObj;
                        let currList = [];
                        if(this.currencyList && this.currencyList.length>selCurrencyObj.length){
                           let deselectedObj =  this.currencyList.filter(o1 => !selCurrencyObj.some(o2 => o1.code === o2.currency_code.code));
                           loop1:for (let i = 0; i < this.currencyList.length; i++) {
                               loop2:for (let j = 0; j < deselectedObj.length; j++) {
                                   if(this.currencyList[i].code == deselectedObj[j].code){
                                       this.$delete(this.currencyList,i);
                                       i--;
                                       break loop2;
                                   }   
                               }   
                           }
                        }
                        for (let index = 0; index < selCurrencyObj.length; index++) {
                            if((!this.currencyList || !this.currencyList[index] || !this.currencyList[index].hasOwnProperty('postpaidlimit'))) {
                            const curr = selCurrencyObj[index];
                            let currObj = {
                                postpaidlimit: "0",
                                code: curr.currency_code.code


                                // let currObj = {

                                // }

                            };
                            currList.push(currObj);
                            }else{
                                currList.push(this.currencyList[index]);
                            }
                            
                        }
                        this.currencyList = currList;
                    }
                     
                    if(this.isSelCurrency){
                     updateDataEdited(true);

                    }
                      this.isSelCurrency=true;
                    //this.agentDetail.currency=currList;
                    // this.agentDetail.currency=removeDuplicates(this.agentDetail.currency,'code');
                    //  currList= differenceBy(currList,this.agentDetail.currency, 'code')
                    //  for (let index = 0; index < currList.length; index++) {
                    //    const curr = currList[index];
                    //    this.agentDetail.currency.push(curr);

                    //  }

                    // if(this.agentDetail.agent){
                    //   for (let index = 0; index < this.agentDetail.agent.b2bCompanyFinancess.length; index++) {
                    //     const curr = this.agentDetail.agent.b2bCompanyFinancess[index];
                    // let currList=differenceBy(selCurrencyObj.currency_code,curr.currencycode,'code');

                    //   }
                    // let currList=differenceBy(selCurrencyObj,this.agentDetail.agent.b2bCompanyFinancess,'code');
                    // if(currList.length>0)
                    // this.agentDetail.agent.b2bCompanyFinancess.push(currList);

                    // }
                    //  if(this.agentDetail.agent.b2bCompanyFinancess && currList){
                    //    let b2bCompanyFinancess=cloneData(this.agentDetail.agent.b2bCompanyFinancess);
                    //     agentCurrency:
                    //   for (let index = 0; index < b2bCompanyFinancess.length; index++) {
                    //     const curr = b2bCompanyFinancess[index];
                    //     currObj:
                    //     for (let index = 0; index < currList.length; index++) {
                    //       const curObj = currList[index];
                    //       if(curr.currencycode.code && curObj.currencycode.code){
                    //       if(curObj.currencycode.code!==curr.currencycode.code){

                    //       this.agentDetail.agent.b2bCompanyFinancess.push(curObj);

                    //     }
                    //     }
                    //     }
                    //   }
                    //  }

                    // }
                    // }
                    // for (let index = 0; index < selCurrencyObj.length; index++) {
                    //   const currObj = selCurrencyObj[index];
                    //   if (
                    //   currObj.currency_code.code != null &&
                    //   this.agentDetail.agent.b2bCompanyFinancess &&
                    //   this.agentDetail.agent.b2bCompanyFinancess.includes(pPaymentId) == false
                    // ) {
                    //   this.agentDetail.agent.paymentsettings.push(pPaymentId);
                    // } else if (
                    //   pPaymentId &&
                    //   this.agentDetail.agent.paymentsettings &&
                    //   this.agentDetail.agent.paymentsettings.length
                    // ) {
                    //   this.agentDetail.agent.paymentsettings = this.agentDetail.agent.paymentsettings.filter(
                    //     id => {
                    //       return id != pPaymentId;
                    //     }
                    //   );
                    // }
                    // }

                    // if (
                    //   pPaymentId != null &&
                    //   this.agentDetail.agent.paymentsettings &&
                    //   this.agentDetail.agent.paymentsettings.includes(pPaymentId) == false
                    // ) {
                    //   this.agentDetail.agent.paymentsettings.push(pPaymentId);
                    // } else if (
                    //   pPaymentId &&
                    //   this.agentDetail.agent.paymentsettings &&
                    //   this.agentDetail.agent.paymentsettings.length
                    // ) {
                    //   this.agentDetail.agent.paymentsettings = this.agentDetail.agent.paymentsettings.filter(
                    //     id => {
                    //       return id != pPaymentId;
                    //     }
                    //   );
                    // }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.MANAGE,
                        "error in onCurrencyChange",
                        err.toString(),
                        "onCurrencyChange",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            onToggleBlockTicket() {
                try {
                  if(BaseConfiguration.isDebug) console.log("onToggleBlockTicket");
                  this.agentDetail.isBlockTicket = !this.agentDetail.isBlockTicket;
            
                } catch (err) {
                        let body = Logger.buildRequest(
                          FILE_NAME.MANAGE,
                          "error in onToggleBlockTicket",
                          err.toString(),
                          "onToggleBlockTicket",
                          LOG_TYPE.ERROR
                        );
                        Logger.getResponse(body);
                      }
                  
            }, 

            onPaymentTypeChange(pPaymentId) {
                try {
                    if (BaseConfiguration.isDebug) console.log("onPaymentTypeChange");
                    this.invalidText = false;
                    if (
                        pPaymentId != null &&
                        this.agentDetail.agent.paymentsettings &&
                        this.agentDetail.agent.paymentsettings.includes(pPaymentId) == false
                    ) {
                        this.agentDetail.agent.paymentsettings.push(pPaymentId);
                    } else if (
                        pPaymentId &&
                        this.agentDetail.agent.paymentsettings &&
                        this.agentDetail.agent.paymentsettings.length
                    ) {
                        this.agentDetail.agent.paymentsettings = this.agentDetail.agent.paymentsettings.filter(
                            id => {
                                return id != pPaymentId;
                            }
                        );
                    }
                    updateDataEdited(true);
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.MANAGE,
                        "error in onPaymentTypeChange",
                        err.toString(),
                        "onPaymentTypeChange",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                // return retValue;
            },

            onStatusChange(pStatus) {
                try {
                  if(BaseConfiguration.isDebug) console.log("onStatusChange");
                  //let retValue;
                  this.agentDetail.agent.isactive = pStatus;
             updateDataEdited(true);
                } catch (err) {
                        let body = Logger.buildRequest(
                          FILE_NAME.MANAGE,
                          "error in onStatusChange",
                          err.toString(),
                          "onStatusChange",
                          LOG_TYPE.ERROR
                        );
                        Logger.getResponse(body);
                      }
                 // return retValue;
                }, 

            async updateStatus(pStatus) {
                try {
                    if (BaseConfiguration.isDebug) console.log("updateStatus");
                    let status = null;
                    let b2bid = null;
                   
                        b2bid = this.agentDetail.agent.b2bid;
                        status = pStatus;
                    

                    let statusReq = apiActivateAgent.buildRequest(b2bid, status);
                    if (statusReq) {
                        let statusRes = await apiActivateAgent.getResponse(statusReq);
                        if (VALIDATE_SUCCESS_RES(statusRes)) {
                            return status;
                            this.showAlert(null);
                            //save res in store
                            // returnValue = statusRes.data.data;
                        } else {
                            let error = getErrorMessage(statusRes);
                            let isJwt = handleJWT(error);
                            if (!isJwt) {
                                this.showAlert(getErrorAlertValue(error));
                            }
                           // returnValue = [];
                        }
                    } else {
                        throw "invalid request"; //
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.MANAGE,
                        "error in updateStatus",
                        err.toString(),
                        "updateStatus",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                //return retValue;
            }
        },

        async created() {
            try{
            if (BaseConfiguration.isDebug) console.log("created");
            if (this.selectedB2bId) {
                this.agentDetail.agent = await this.getAgentDetail(this.selectedB2bId);
            }
            if (this.agentDetail.agent) {
                this.selectedCurrencyList = this.getCurrencyList(this.agentDetail.agent);
                this.agentDetail.status.value = this.agentDetail.agent.isactive;
                this.agentDetail.status.name = this.agentDetail.agent.isactive
                    ? DEFAULT_DROPDOWN_STATUS.ACTIVE
                    : DEFAULT_DROPDOWN_STATUS.INACTIVE;
                this.paymentList = await this.getPaymentList(this.agentDetail.agent);
                if(this.paymentList.length>0){
                    this.paymentListGroup = GroupByList(this.paymentList, "groupName", "payment");
                }
                this.agentDetail.currency = this.getCurrency(this.agentDetail.agent);
                this.agentDetail.extensionTimes = this.agentDetail.agent.max_stmt_extenstion_times!=null ?
                                                  this.agentDetail.agent.max_stmt_extenstion_times : null;
                this.agentDetail.isBlockTicket = this.agentDetail.agent.is_block_ticket_ifonestatementpending != null?
                                                 this.agentDetail.agent.is_block_ticket_ifonestatementpending:this.agentDetail.agent.agenttype==2?false:null
                this.isAdvanceSettings = this.agentDetail.agent.max_stmt_extenstion_times!=null?true:false
            } else {
                this.navigateToManageAgents();
            }
            this.isLoading=false;

            } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.MANAGE,
                        "error in created",
                        err.toString(),
                        "created",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
        },
        beforeCreate() {
            addClassToBody(COMPONENT_NAME.MANAGE);
        },

        beforeDestroy() {
            removeClassBody();
        },
    };
</script>

<style scoped>
    /* .currency li {
      display: inline;
    } */
    .curr {
        display: inline;
    }
</style>
